import { countries, states } from "@/constants/geography";
import { LoadsClientAttributes } from "@/types/clientAttributes";
import { Client, Coach } from "@/types/page";

export function clientDescription(
    client: Client & LoadsClientAttributes,
): string {
    if (!client.attributes) return "";

    const descriptors = [];
    if (client.attributes.fuzzy_age) {
        descriptors.push(client.attributes.fuzzy_age);
    }
    if (client.attributes.gender) {
        descriptors.push(client.attributes.gender);
    }
    if (client.country_code) {
        if (client.country_code === "US" && client.region_code) {
            descriptors.push(
                `${states[client.region_code]} (${client.country_code})`,
            );
        } else {
            descriptors.push(countries[client.country_code]);
        }
    }
    return descriptors.join(", ");
}

export function coachWithCerts(coach: Coach): string {
    return `${coach.first_name} ${coach.last_name} (${coach.certifications})`;
}

export function coachWithCertsForceInitialLastName(coach: Coach): string {
    return `${coach.first_name} ${coach.last_name.charAt(0)}. (${coach.certifications})`;
}
